// extracted by mini-css-extract-plugin
export default {"thumbnail":"SecurityGuidelines_thumbnail__VvibX"};